import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Image } from 'react-bootstrap';
import { refreshMenu } from '../../redux/refreshMenu';
import { getCookies } from '../../hooks/useCookies';
import { TableContext } from '../../contexts/tableContext';
import envValues from '../../enviornment';
import { getDefaultAdminHomePath } from '../../utils/menuAccess';
import pagenotfoundBg from '../../assets/permissiondenied.png';
import styles from './permission.module.scss';

function PermissionDeniedModal() {
  const navigate = useNavigate();
  const userRole = `${getCookies('USERROLE')}`;
  const dispatch = useDispatch();
  const {
    permissionDeniedOpen,
    setPermissionDeniedOpen,
    userMenus,
    setUserMenus,
  } = useContext(TableContext);

  useEffect(() => {
    if (!permissionDeniedOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setPermissionDeniedOpen(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [permissionDeniedOpen, setPermissionDeniedOpen]);

  useEffect(() => {
    if (!permissionDeniedOpen) return;
    const token = getCookies('Token');
    if (!token || userMenus?.length) return;

    axios
      .get(`${envValues.REACT_APP_API_ENDPOINT}/notifications/getUserMenu`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data?.code === 200 && Array.isArray(res.data.data?.userMenu)) {
          setUserMenus(res.data.data.userMenu);
        }
      })
      .catch(() => {});
  }, [permissionDeniedOpen, userMenus, setUserMenus]);

  const closeModal = () => setPermissionDeniedOpen(false);

  const handleGoHome = () => {
    closeModal();
    navigate(getDefaultAdminHomePath(userMenus));
  };

  const handleRefreshPermissions = () => {
    const token = getCookies('Token');
    dispatch(refreshMenu(userRole)).then(() => {
      if (!token) {
        closeModal();
        navigate(getDefaultAdminHomePath(userMenus));
        return;
      }
      axios
        .get(`${envValues.REACT_APP_API_ENDPOINT}/notifications/getUserMenu`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          const menus = res.data?.data?.userMenu;
          closeModal();
          if (res.data?.code === 200 && Array.isArray(menus)) {
            setUserMenus(menus);
            navigate(getDefaultAdminHomePath(menus));
            return;
          }
          navigate(getDefaultAdminHomePath(userMenus));
        })
        .catch(() => {
          closeModal();
          navigate(getDefaultAdminHomePath(userMenus));
        });
    });
  };

  if (!permissionDeniedOpen) {
    return null;
  }

  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="permission-denied-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          closeModal();
        }
      }}
    >
      <div className={styles.modal}>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={closeModal}
          aria-label="Close"
        >
          ×
        </button>

        <div className={styles.iconBadge} aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2a5 5 0 0 0-5 5v2.1a2 2 0 0 0-.9 1.68V20a2 2 0 0 0 2 2h7.8a2 2 0 0 0 2-2v-9.22A2 2 0 0 0 17.1 10.1V7a5 5 0 0 0-5-5z"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinejoin="round"
            />
            <path
              d="M9 14h6"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <div className={styles.imgdiv}>
          <Image src={pagenotfoundBg} alt="" className={styles.pagenotimage} />
        </div>

        <h1 id="permission-denied-title" className={styles.title}>Access Denied</h1>
        <p className={styles.subtitle}>
          You don&apos;t have permission to view this page or perform this action.
        </p>
        <p className={styles.hint}>
          If your access was recently updated, refresh your permissions or return to your home page.
        </p>

        <div className={styles.btnsection}>
          <button type="button" onClick={handleGoHome} className={styles.primaryBtn}>
            Go to Dashboard
          </button>
         
        </div>
      </div>
    </div>
  );
}

export default PermissionDeniedModal;
